import React, { Fragment } from 'react';

import Box from 'components/elements/Box';
import useMedia from 'hooks/useMedia';
import { Container, H2, StatusWrapper, Loader } from './shared/styles';
import times from 'lodash.times';

export const TextLoader = (): JSX.Element => (
  <Loader width={1500} height={150} uniquekey="Skeleton">
    {times(3, (idx) => (
      <Fragment key={`event-skeleton-${idx}`}>
        <rect width="1500" height="25" y={20 + 40 * idx} />
      </Fragment>
    ))}
  </Loader>
);

const StatusUpdateSkeletonLoader: React.FC<{ title: string }> = ({ title }) => {
  const isMobileView = useMedia('(max-width: 50em)');

  return (
    <Container isMobileView={isMobileView} data-pw="status-update-loader">
      <Box mt={4} pb={3}>
        <H2>{title}</H2>
        <StatusWrapper>
          <TextLoader />
        </StatusWrapper>
      </Box>
    </Container>
  );
};

export default StatusUpdateSkeletonLoader;
